<template>
  <div class='mb-30'>
    <div class='bg-cream-deep tc pt-50 pb-50 pl-30 pr-30 mb-pb-30 mb-pt-30 br-14'>
      <template v-if='(checkGlobalGallery || pageTypeName) && !isFreeCancellationPage'>
        <h2 class='mb-20 fs-36 mb-fs-28 fw-900'>
          <template v-if='pageLevel===0 && pageTypeSetting==="activity" || pageLevel===0 &&  pageTypeSetting==="theme"'>
            Have you got something specific in mind for your {{ pageTypeName }} trip?

          </template>
          <template v-else-if="isCountryNoTripHasLDCoverage"> Looking to travel to {{ pageTypeName }}? Speak with our Local Designers to build you something extraordinary.</template>
          <template v-else> Have you got something specific in mind for your trip to {{ pageTypeName }}?</template>
        </h2>
        <p class='mb-30 fs-18 lh-22'>
          <template v-if='pageLevel===0 && pageTypeSetting==="activity" || pageLevel===0 &&  pageTypeSetting==="theme"'>
            No problem. Tell us what you're looking for in your perfect {{ pageTypeName }} trip and our Local Designers will design it for you!
          </template>
          <template v-else-if="isCountryNoTripHasLDCoverage">
            We have some amazing Local Designers who are available to build your very own customised itinerary. To get started all your need to do is share some details with us and we will get to work brining your trip idea’s to {{ pageTypeName }} to life.
          </template>
          <template v-else>
            No problem. Tell us what you're looking for in your perfect trip to {{ pageTypeName }} and our Local Designers will design it for you!
          </template>
        </p>
      </template>
      <template v-else>
        <h2 class='mb-20 fs-36 mb-fs-28 fw-900'>
          Have you got something specific in mind for your trip?
        </h2>
        <p class='mb-30 fs-18 lh-22'>
          No problem. Tell us what you're looking for in your perfect trip and our Local Designers will design it for you!
        </p>
      </template>
      <div class='flex items-center justify-center'>
        <client-only>
          <router-link :to='designURL()' @click="heapTracking" class='hand'>
            <span v-if="isCountryNoTripHasLDCoverage" class='button button-accent'>Enquire now</span>
            <span v-else class='button button-accent'>Tell Us Your Plans</span>
          </router-link>
        </client-only>
      </div>
    </div>
  </div>

</template>

<script>
import { computed } from 'vue'
import { publicDomain } from '~/helper'
import { useRoute } from 'vue-router'
import { debounceHeapTracking } from '~/mixins/heap'
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
export default {
  name: "DesignTrip",
  props: {
    urlDesignEnquiry : {type: String, default: ''},
    checkGlobalGallery: {type: Boolean, default: false},
    pageTypeName: {type: String, default: ''},
    pageTypeSetting: {type: String, default: ''},
    pageLevel: {type: Number, default: 0},
    isCountryNoTripHasLDCoverage: {type: Boolean, default: false},
  },
  setup(props) {
    const domain = publicDomain()
    const route = useRoute()
    const {isMobile} = useDevice()
    const tripPlanStore = useTripPlanStore()
    
    const trip_plan_name = computed(() => tripPlanStore?.dataTrip?.name)


    const isFreeCancellationPage = computed(() => {
      return route.name === "free-cancellation-trips" ? true : false
    })

    const heapTracking = () => {
      debounceHeapTracking("View Enquiry", {
        source_widget: props.isCountryNoTripHasLDCoverage ? "Design Trip CTA No result" : "Design Trip CTA",
        source_type: route.name,
        type: domain === 'agent' ? "b2b" : "b2c",
        trip_plan_name: route.name === 'trip-plan' ? trip_plan_name.value : '',
      });
      debounceAmplitudeScriptTracking("View Enquiry", {
        source_widget: props.isCountryNoTripHasLDCoverage ? "Design Trip CTA No result" : "Design Trip CTA",
        source_type: route.name,
        type: domain === 'agent' ? "b2b" : "b2c",
        trip_plan_name: route.name === 'trip-plan' ? trip_plan_name.value : '',
      });
    }

    const designURL = () => {
      const galleryTypes = props.urlDesignEnquiry.replace('/', '')
      if((props.checkGlobalGallery || galleryTypes) && !isFreeCancellationPage.value) {
        if(!galleryTypes) return { name: 'enquiry-submit-global' }
          return { name: 'enquiry-submit-destination', params: { galleryTypes: galleryTypes }}
      } else {
          return { name: 'enquiry-submit-global' }
      }

    }
    return {
      isMobile,designURL,isFreeCancellationPage, heapTracking
    }
  }
}
</script>
<style lang='scss' scoped>
.button-primary {
  height: 40px;
  min-height: 40px; // band CTA keeps its compact height (was .button-brand-800)
}
</style>
